import style from "./components/DoctorCard.module.scss";
import {doctor, errRules} from "./DoctorsType";
export function getClassOnlineDoctor(doctor: doctor): string {
  const {status, updated_at} = doctor;
  if (status == true && !checkRulesDoc(doctor)) {
    return style.online + " " + style.warning;
  }
  if (checkUpdatedDoctor(updated_at) > 168) {
    return style.online + " " + style.deactivation;
  }
  if (checkUpdatedDoctor(updated_at) > 35) {
    return style.online + " " + style.warning;
  }
  return style.online + " " + style.active;
}
export function checkRulesDoc(doctor: doctor): boolean {
  if (Object.values(getErrRules(doctor)).length != 0) {
    return false;
  }
  return true;
}
export function getErrRules(doctor: doctor): errRules {
  let errRules: errRules = {};
  if (doctor.specialization.length == 0) {
    errRules["specialization"] = "Выберете специализацию";
  }
  if (
    doctor.service == undefined ||
    Object.values(doctor.service).length == 0
  ) {
    errRules["direction"] = "Выберете направление";
  }
  let service: boolean[] = [];
  if (doctor.service != undefined) {
    Object.values(doctor.service).forEach((directionObj) => {
      if (directionObj != null) {
        let serviceArr = Object.values(directionObj);
        serviceArr.forEach((serviceObj) => {
          service.push(serviceObj.checked);
        });
      }
    });
  }
  if (!service.includes(true)) {
    errRules["service"] = "Выберете как минимум 1 услугу";
  }
  if (!Object.values(doctor.address).includes(true)) {
    errRules["address"] = "Выберете как минимум 1 адрес";
  }
  if (doctor.appointment == undefined) {
    errRules["appointment"] = "У врача нет расписания";
  }
  return errRules;
}
export function checkUpdatedDoctor(updated: string): number {
  let hours = (new Date().getTime() - new Date(updated).getTime()) / 3600000;
  hours = Math.floor(hours);
  return hours;
}
export function sortDataName(a: doctor, b: doctor): number {
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }
  return 0;
}
export function sortDataStatus(a: doctor, b: doctor): number {
  function getNumberStatus(c: doctor): number {
    switch (getClassOnlineDoctor(c)) {
      case style.online + " " + style.warning:
        return 1;
      case style.online + " " + style.active:
        return 3;
    }
    return 2;
  }
  let statusA = getNumberStatus(a);
  let statusB = getNumberStatus(b);

  if (statusA > statusB) {
    return 1;
  }
  if (statusA < statusB) {
    return -1;
  }
  return 0;
}
